import { Box, Checkbox, Image, Text, Icon } from "@oneloop/jopijs";
import React, { useEffect, useState } from "react";
import style from "./imagesEdition.module.scss";
import { validateImageEnabled } from "../fichaInfo/utilities/helpers";
import imgError from "../../public/imageError.svg";
import Skeletons from "../fichaInfo/skelenton/Skeleton";
import Trans from "../shared/Trans";
import translations from "../fichaInfo/FichaInfo.trans.json";

export default function CardEdition({
  file,
  handleChange,
  handleMainSelect,
  main = false,
  check,
  type,
}) {
  const infoToTest = JSON.stringify({ file, main, type });
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const isImage = file.includes("pictures");

  useEffect(() => {
    validateImageEnabled(file)
      .then(() => setError(false))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [file]);

  if (loading)
    return <Skeletons className={style.skeletonCard}>Cargando</Skeletons>;

  if (error && (type === "images" || type === "blueprints"))
    return (
      <Box className={`${style.cardError} ${check && style.isCheked}`}>
        {isImage ? (
          <Image src={imgError.src} alt="image error" />
        ) : (
          <Icon icon="icon-video" color="var(--neutralGray1)" fontSize="24px" />
        )}
        <Text color="var(--neutralGray1)">
          {Trans(translations, "LoadFileErrorTitle")}{" "}
          {isImage
            ? Trans(translations, "LoadFileErrorTypePicture")
            : Trans(translations, "LoadFileErrorTypeVideo")}
        </Text>
        <Box className={style.checkbox}>
          <Checkbox
            onChange={(e) => handleChange(e.target.checked, file, type)}
            onClick={(e) => e.stopPropagation()}
            data-testid="image-checkbox"
            isMedium
            defaultChecked={check}
          />
        </Box>
      </Box>
    );

  return (
    <Box>
      {type === "images" || type === "blueprints" ? (
        <Box
          className={`${style.cardEdition} ${check && style.isCheked}`}
          data-testid="images-card"
          data-imageenabled={check}
          data-file={infoToTest}
          onClick={check && !main ? () => handleMainSelect(type, file) : null}
        >
          <Image height="100%" src={file} className={style.imageCard} />
          <Box className={style.checkbox}>
            <Checkbox
              onChange={(e) => handleChange(e.target.checked, file, type)}
              onClick={(e) => e.stopPropagation()}
              data-testid="image-checkbox"
              isMedium
              defaultChecked={check}
            />
          </Box>
          {main && (
            <Box className={style.main}>
              <Text variant="body.fontSize12">Portada</Text>
            </Box>
          )}
        </Box>
      ) : (
        <Box
          className={`${style.cardEdition} ${check && style.isCheked}`}
          key={file}
          data-testid="video-card"
          data-videoenabled={check}
          data-file={infoToTest}
        >
          <iframe
            height="100%"
            width="100%"
            src={file}
            className={style.imageCard}
            title="myFrame"
            allowFullScreen
          />
          <Box className={style.checkbox}>
            <Checkbox
              onChange={(e) => handleChange(e.target.checked, file, type)}
              data-testid="video-checkbox"
              isMedium
              defaultChecked={check}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
